<template>
<div class="container">
  <div class="row mb-3 border-bottom">
    <div class="col-auto fw-bold text-info">{{accountName}}</div>
    <div v-if="chartData" class="col-auto ms-auto fst-italic text-info">Total Failed Transactions: {{chartData.totalCount}}</div>
  </div>
  
  <wait-loading :loading="isLoading"></wait-loading>
  
  <div id="chart" v-if="chartData">
    <apexchart 
      type="pie" 
      width="600" 
      height="600"
      :options="chartOptions" 
      :series="chartData.top10Counts">
    </apexchart>
  </div>

  <div class="row border-top mt-3" v-if="chartData && chartData.others && chartData.others.length > 0">
    <div class="col-auto ms-auto mt-2">
      <table class="table table-sm small text-info">
        <thead>
          <tr>
            <th colspan="2">* Others</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in chartData.others" :key="item.label">
            <td class="small pe-5">{{item.label}}</td>
            <td class="text-end">{{item.count}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'FailedTxnsChart',
  mixins: [HelpersMixin],
  props: ['merchantId', 'accountId', 'baseDate', 'period', 'accountName'],
  components: {
      apexchart: VueApexCharts,
  },
  data () {
    return {
      chartData: null,
      isLoading: true,
      chartOptions: {
          chart: {
            type: 'pie',
          },
          labels: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 300
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
    }
  },
  mounted() {
    this.chartData = this.getChartData()
  },
  methods: {
    getChartData: function () {
      this.isLoading = true
      this.axios.post('/ax/chartdata/failedtxns', {period: this.period, dateStr: this.baseDate, merchantId: this.merchantId, accountId: this.accountId})
      .then(response => {
        this.chartData = response.data
        this.chartOptions = {
                ...this.chartOptions,
                labels: this.chartData.top10Labels
              }
        this.isLoading = false
      })
      .catch(error => this.handleError(error))
    }
  }
}
</script>